const QualityBadge = ({ value }) => {
  const categories = [
    { label: "Excellent", min: 0.95, max: 1, color: "success" },
    { label: "Very Good", min: 0.85, max: 0.94, color: "primary" },
    { label: "Good", min: 0.75, max: 0.84, color: "info" },
    { label: "Fair", min: 0.6, max: 0.74, color: "warning" },
    { label: "Poor", min: 0.4, max: 0.59, color: "danger" },
  ];

  const category = categories.find(
    (cat) => value >= cat.min && value <= cat.max
  ) || { label: "Unknown", color: "secondary" };

  return (
    <span className={`badge ml-2 badge-${category.color}`}>
      {category.label}
    </span>
  );
};

export default QualityBadge;
